import { useState, type FormEvent } from "react";
import { postSubscribe } from "../../api/client";
import { useBotProtection } from "../../hooks/useBotProtection";
import { HoneypotField } from "./HoneypotField";
import { TurnstileWidget } from "./TurnstileWidget";

type State = "idle" | "loading" | "ok" | "err";

export function NewsletterForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState<State>("idle");
  const [error, setError] = useState<string | null>(null);
  const {
    config,
    needsTurnstile,
    ready,
    website,
    setWebsite,
    botFields,
    onTurnstileToken,
    onTurnstileExpire,
    registerTurnstileReset,
    resetBotProtection,
  } = useBotProtection();

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!ready) return;
    setState("loading");
    setError(null);
    try {
      await postSubscribe({
        email,
        ...(name.trim() ? { name: name.trim() } : {}),
        ...botFields,
      });
      setState("ok");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Subscription failed");
      setState("err");
      resetBotProtection();
    }
  }

  return (
    <form className="news-form-wrap" onSubmit={onSubmit}>
      <HoneypotField value={website} onChange={setWebsite} />
      <div className="news-form">
        <input
          type="text"
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={state === "loading"}
          autoComplete="name"
        />
        <input
          type="email"
          placeholder="your.email@domain.com"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={state === "loading"}
          autoComplete="email"
        />
        <button type="submit" disabled={state === "loading" || !ready}>
          {state === "ok" ? "Added ✓" : state === "loading" ? "…" : "Subscribe"}
        </button>
      </div>
      {needsTurnstile && config?.turnstileSiteKey && (
        <TurnstileWidget
          siteKey={config.turnstileSiteKey}
          onToken={onTurnstileToken}
          onExpire={onTurnstileExpire}
          onRegisterReset={registerTurnstileReset}
        />
      )}
      {error && (
        <div style={{ color: "var(--accent-2)", fontSize: 12, marginTop: 8 }}>
          {error}
        </div>
      )}
    </form>
  );
}
